"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDirty = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _lodash = require("lodash");

var _layouts = require("./layouts");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isDirty = function isDirty(value, currentValue) {
  var draftValue = value && value.value;
  var publishedValue = currentValue && currentValue.value;
  return !(0, _lodash.isEqual)(draftValue, publishedValue);
};

exports.isDirty = isDirty;

var Layout = function Layout(_ref) {
  var layout = _ref.layout,
      props = (0, _objectWithoutProperties3.default)(_ref, ["layout"]);
  var LayoutDelegate = (0, _layouts.getLayout)(layout, "list");
  return React.createElement(LayoutDelegate, (0, _extends3.default)({
    layout: layout
  }, props));
};

exports.default = Layout;